import CardReveal from './card-reveal.jsx';
export default CardReveal;
